import { useState, useMemo } from 'react';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useSnackbar } from 'src/components/snackbar';
import FormProvider from 'src/components/hook-form';
import { postRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import { handleErrorMessages } from '../../risk-register/feching';
import EmployeeUserAdd from 'src/components/accounts-management/SideCards.js/payroll/employe-add-plus-signature';
import ProjectManagerADD from 'src/components/risk-project-user-drop/project-user-drop';
import { useNavigate } from 'react-router';
const WeeklyViewDrawComp = ({ reload, currentItem, id, rowData }) => {
    console.log("🚀 ~ WeeklyViewDrawComp ~ rowData:", rowData)
    const { enqueueSnackbar } = useSnackbar();
    const [ loading, setLoading ] = useState(false);
    const [ selectedEmployee, setSelectedEmployee ] = useState(null); 
    const [ selectedPM, setSelectedPM ] = useState(null); 

    const navigate = useNavigate()
    const NewDocumentSchema = Yup.object().shape({});

    const defaultValues = useMemo(() => ({}), []);

    const methods = useForm({
        resolver: yupResolver(NewDocumentSchema),
        defaultValues,
    });

    const {
        reset,
        handleSubmit,
        setValue,
        watch,
        formState: { isSubmitting },
    } = methods;

    const onSubmit = handleSubmit(async (data) => {
        setLoading(true);
        const formData = new FormData();
        formData.append('project_id', rowData?.project?.id);
        formData.append('employee_id', selectedEmployee?.id || data.employee_id || ''); 
        formData.append('project_manager_id', selectedPM?.id || data.project_manager_id || '');
        try {
            const response = await postRequest(
                `${endpoints.accounting.payroll.weeklyPayroll.weekly_view_create}/${rowData?.id}?_method=PUT`,
                formData,
                true
            );
            if (response.metadata?.success) {
                reset();
                // reload();
                navigate(`/accounts-management/payroll-project-list/payroll/${rowData?.project?.id}`)
                enqueueSnackbar({
                    variant: 'success',
                    message: response.metadata.message,
                });
            } else {
                handleErrorMessages(response.message || 'An error occurred.');
            }
        } catch (err) {
            console.error('Error:', err);
            handleErrorMessages(err.message || 'Submission failed.');
        } finally {
            setLoading(false);
        }
    });

    const selectedProjectManager = watch('project_manager_id'); // Watch the selected supervisor
    return (
        <FormProvider methods={ methods } onSubmit={ onSubmit }>
            <Box p={ 3 } mt={ 3 } rowGap={ 3 } columnGap={ 2 } display="grid" gridTemplateColumns={ { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' } }>
                {/* Employee Section */ }
                <Box>
                    <Typography variant="h6" gutterBottom>
                        Employee
                    </Typography>
                    <EmployeeUserAdd
                        name="employee_id"
                        label="Employee Name"
                        onRiskOwnerChange={ setSelectedEmployee } 
                    />

                    {selectedEmployee?.signature && (
                        <Box mt={ 2 }>
                            <Typography variant="body2">Signature:</Typography>
                            <img src={ selectedEmployee?.signature } alt="Employee Signature" width={ 150 } />
                        </Box>
                    ) }
                </Box>

                {/* Project Manager Section */ }
                <Box>
                    <Typography variant="h6" gutterBottom>
                        Project Manager
                    </Typography>
                    <ProjectManagerADD
                        label="Project Manager"
                        name="project_manager_id"
                        project_id={rowData?.project?.id}
                        onValueChange={setSelectedPM}
                        

                    />
                 {selectedPM?.signature && (
                        <Box mt={ 2 }>
                            <Typography variant="body2">Signature:</Typography>
                            <img src={ selectedPM?.signature } alt="Employee Signature" width={ 150 } />
                        </Box>
                    ) }
                </Box>
            </Box>

            <Box display="flex" justifyContent="flex-end" alignItems="center" p={ 2 }>
                <LoadingButton type="submit" variant="contained" className="dark-button" loading={ isSubmitting }>
                    Submit
                </LoadingButton>
            </Box>
        </FormProvider>
    );
};

export default WeeklyViewDrawComp;
